import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import {
  IoIosInformationCircle,
  IoIosInformationCircleOutline,
  IoMdClose,
} from "react-icons/io";

export default function DocumentUploadFilePopUp_Muqeem({
  PopUp,
  setPopUp,
  url,
  title,
  // callBack,
  fileFormat,
  fileNme,
  setTrigger,
  trigger,
  setData
  // list
}) {
  console.log(".......fileFormat.....", fileFormat);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [error, setError] = useState();
  const [errorShow, setErrorShow] = useState(false);

  const handleFileChange = (e) => {
    // Retrieve the selected files
    const selectedFiles = Array.from(e.target.files);
    // Update the state with the selected files
    console.log(selectedFiles);
    setFile(selectedFiles);
  };

  const token = localStorage.getItem("nodeToken");
  const submitHandler = async (e, fileData, propData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();
    setFile(fileData);
    update();
  };
  const update = async () => {
    const formData = new FormData();
    file.forEach((filelist, index) => {
      console.log();
      formData.append(`files`, filelist);
    });
    setLoading(true);
    try {
      const response = await nodeinstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        console.log("Upload response to be printed in the console", response);
        dispatch(
          setAppError({
            msg: `${response?.data?.data?.length} Employees uploaded successfully`,
            color: "success",
          })
        );
        if (response.data.errors.length > 0) {
          setErrorShow(true);
          setError(response.data);
          setLoading(false);
          setData();
          return;
        }
        setPopUp(false);
        setLoading(false);
        // callBack();
        setTrigger(!trigger);
        setData();
      }
    } catch (error) {
      setLoading(false);
      // dispatch(
      //   setAppError({
      //     msg: error?.response?.data.error,
      //   })
      // );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {errorShow ? (
            error.errors.map((data, index) => (
              <div key={index}>
                <p key={index}>
                  {data?.employeeData} -{" "}
                  <span style={{ color: "red" }}>{data?.messege}</span>
                </p>
              </div>
            ))
          ) : (
            <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
              <div className="w-full flex flex-col gap-3 my-3 p-5">
                <div className="form-control w-full ">
                  <label className="label">
                    <span className="label-text">{title}</span>
                  </label>
                  <div className="flex justify-center items-center gap-4">
                    <input
                      type="file"
                      className="file-input file-input-bordered w-full"
                      onChange={handleFileChange}
                      required
                      accept="application/xls, application/xlsx"
                      multiple // Enable multiple file selection
                    />

                    <div className="relative">
                      <div className="peer  w-fit">
                        <button className="flex items-center gap-2 opacity-90  p-2 px-3  rounded-md w-fit text-xs text-center ">
                          <IoIosInformationCircle size={"2rem"} />
                        </button>
                      </div>
                      <div
                        className={
                          "hidden absolute -top-[5.5rem] right-0 transform  max-w-sm w-[15rem] h-auto bg-white shadow-xl rounded-lg p-2 ring-1 ring-slate-400  peer-hover:flex hover:flex flex-col gap-2"
                        }
                      >
                        <h6 className="font-bold text-sm">File Name Format:</h6>
                        <p className="text-xs ">{fileNme}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  {file.map((file, index) => (
                    <div key={index}>{file.name}</div>
                  ))}
                </div>
                <div
                  className="flex gap-3 w-full justify-center"
                  style={{ margin: 2 }}
                >
                  <button
                    type="Submit"
                    className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                  >
                    {" "}
                    <p>Submit</p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
